import { useEffect, useState } from "react";
import Axios from "axios";
import { Modal } from "react-bootstrap";
import { URL_LIST_ALL } from "../../../configs/api";
import { useSelector } from "react-redux";

export default function QuanLyBangHang({ duan_id }) {
    const { user } = useSelector((state) => state.auth);
    const [listCustomer, setListCustomer] = useState([]);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showBangHang, setShowBangHang] = useState(false);
    const [floors, setFloors] = useState([]);
    const [activeFloor, setActiveFloor] = useState("all");
    const [searchTerm, setSearchTerm] = useState("");
    const [editingData, setEditingData] = useState({});
    const [STATUS_OPTIONS, SET_STATUS_OPTIONS] = useState([]);

    useEffect(() => {
        if (user?.access_token) {
            Axios.get(URL_LIST_ALL + "banghang_settings", user.config).then(async (res) => {
                if (res.data.status === "success") {
                    let new_list = [];
                    const data = res.data.data
                    data.forEach(item => {
                        new_list.push({
                            value: item.id,
                            label: item.title,
                            background_color: item.background_color,
                            text_color: item.text_color,
                            action: item.action
                        },)
                    });
                    SET_STATUS_OPTIONS(new_list);
                } else console.log(res.data.message);
            }).catch((err) => console.log(err));
        }
    }, [user]);

    const limit = 100000;

    const fetchCustomers = async () => {
        setLoading(true);
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${user.access_token}`,
                    "Content-Type": "application/json; charset=UTF-8",
                },
            };
            const response = await Axios.get(
                `${URL_LIST_ALL}banghang?duan_id=${duan_id}&limit=${limit}`,
                config
            );
            if (response.data.status === "success") {
                const rawData = response.data.data || [];
                const sortedData = rawData.sort((a, b) => {
                    const compareLo = a.thuoclo.localeCompare(b.thuoclo);
                    return compareLo !== 0 ? compareLo : a.sotang - b.sotang;
                });
                setListCustomer(sortedData);
                const uniqueFloors = [...new Set(sortedData.map(item => item.sotang))];
                setFloors(uniqueFloors.sort((a, b) => a - b));
            } else {
                console.warn(response.data.message);
            }
        } catch (err) {
            console.error("Lỗi lấy danh sách khách hàng:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (user?.access_token && showBangHang) {
            fetchCustomers();
        }
    }, [user, showBangHang]);

    useEffect(() => {
        let result = listCustomer;
        if (activeFloor !== 'all') {
            result = result.filter(item => item.sotang === activeFloor);
        }
        if (searchTerm.trim() !== '') {
            result = result.filter(item =>
                item.title.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        setFilteredCustomers(result);
    }, [activeFloor, searchTerm, listCustomer]);

    const handleFloorFilter = (floor) => {
        setActiveFloor(floor);
    };

    const handleChange = (id, field, value) => {
        setEditingData(prev => ({
            ...prev,
            [id]: {
                ...prev[id],
                [field]: value
            }
        }));
    };

    const handleSave = (id) => {
        if (!editingData[id]) return;
        editBangHang(id, editingData[id]);
        setListCustomer(prev =>
            prev.map(item =>
                item.id === id ? { ...item, ...editingData[id] } : item
            )
        );
        setEditingData(prev => {
            const newData = { ...prev };
            delete newData[id];
            return newData;
        });
    };

    const editBangHang = (bhid, values) => {
        Axios.put(URL_LIST_ALL + 'banghang/' + bhid, values, user.config).then(res => {
            if (res.data.status != "success") {
                alert(res.data.message)
            } else {
                alert("Lưu thành công")

            }
        }).catch(err => console.log(err));
    };

    const getStatusColor = (status) => {
        const option = STATUS_OPTIONS.find(opt => opt.value === status);
        return { background_color: option?.background_color || "#FFF", text_color: option?.text_color || "#1F2020", action: option?.action || null };
    };

    const style_tr = (status) => {
        const status_group = getStatusColor(status)
        let rs = { backgroundColor: status_group.background_color, color: status_group.text_color }
        return rs
    }
    const checkOptions = (status, item) => {
        const status_group = getStatusColor(status)

        if (status_group.action && status_group.action == 'Lock') {
            return <div className="form-group input-group">
                <input
                    type="text"
                    className="form-control height32"
                    placeholder="Thời gian khóa phút"
                    value={editingData[item.id]?.time_lock ?? item.time_lock}
                    onChange={(e) => handleChange(item.id, 'time_lock', e.target.value)}
                />
                <div className="input-group-append">
                    <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                        <i className="fas fa-save"></i>
                    </button>
                </div>
            </div>
        }
        return null
    }
    return (
        <div className="w-100">
            <button type="button" className="btn btn-sm btn-info" onClick={() => setShowBangHang(true)}>Mở bảng hàng</button>

            <Modal show={showBangHang} onHide={() => setShowBangHang(false)} animation={true} size="full">
                <Modal.Header closeButton>
                    <Modal.Title>Thông tin bảng hàng</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <div className="d-flex justify-content-center"><div className="loader"></div></div>
                    ) : (
                        <>
                            <div className="d-flex flex-wrap align-items-center btn-group-tang mb-2">
                                <button
                                    className={`btn btn-sm m-1 ${activeFloor === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleFloorFilter('all')}
                                >
                                    Tất cả
                                </button>
                                {floors.map(floor => (
                                    <button
                                        key={floor}
                                        className={`btn btn-sm m-1 ${activeFloor === floor ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleFloorFilter(floor)}
                                    >
                                        Tầng {floor}
                                    </button>
                                ))}
                                <div className="form-group mb-0 ms-auto" style={{ width: '250px' }}>
                                    <input
                                        type="text"
                                        className="form-control height32"
                                        placeholder="Tìm theo mã căn..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>

                            {filteredCustomers.length > 0 ? (
                                <div className="table-scroll-wrapper">
                                    <table className="table table-bordered table-hover table-banghang">
                                        <thead>
                                            <tr>
                                                <th className="sticky-col">Stt</th>
                                                <th className="sticky-col-2">Mã căn</th>
                                                <th className="w-120">Tòa/Lô</th>
                                                <th className="w-120">Tầng</th>
                                                <th className="w-120">Phòng ngủ</th>
                                                <th className="w-120">Phòng khách</th>
                                                <th className="w-120">Phòng WC</th>
                                                <th className="w-160">Hướng nhà</th>
                                                <th className="w-120">Diện tích</th>
                                                <th className="w-170">Giá bán</th>
                                                <th className="w-170">Đơn giá</th>
                                                <th className="w-250">Trạng thái</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredCustomers.map((item, key) => (
                                                <tr key={item.id} style={style_tr(editingData[item.id]?.status ?? item.status)}>
                                                    <td className="sticky-col" style={style_tr(editingData[item.id]?.status ?? item.status)}>{key + 1}</td>
                                                    <td className="sticky-col-2" style={style_tr(editingData[item.id]?.status ?? item.status)}>
                                                        <div className="form-group input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control height32"
                                                                value={editingData[item.id]?.title ?? item.title}
                                                                onChange={(e) => handleChange(item.id, 'title', e.target.value)}
                                                                onBlur={() => handleSave(item.id)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') handleSave(item.id); }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </td>
                                                    <td>
                                                        <div className="form-group input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control height32"
                                                                value={editingData[item.id]?.thuoclo ?? item.thuoclo}
                                                                onChange={(e) => handleChange(item.id, 'thuoclo', e.target.value)}
                                                                onBlur={() => handleSave(item.id)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') handleSave(item.id); }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-group input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control height32"
                                                                value={editingData[item.id]?.sotang ?? item.sotang}
                                                                onChange={(e) => handleChange(item.id, 'sotang', e.target.value)}
                                                                onBlur={() => handleSave(item.id)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') handleSave(item.id); }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-group input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control height32"
                                                                value={editingData[item.id]?.sophongngu ?? item.sophongngu}
                                                                onChange={(e) => handleChange(item.id, 'sophongngu', e.target.value)}
                                                                onBlur={() => handleSave(item.id)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') handleSave(item.id); }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-group input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control height32"
                                                                value={editingData[item.id]?.sophongkhach ?? item.sophongkhach}
                                                                onChange={(e) => handleChange(item.id, 'sophongkhach', e.target.value)}
                                                                onBlur={() => handleSave(item.id)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') handleSave(item.id); }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-group input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control height32"
                                                                value={editingData[item.id]?.sowc ?? item.sowc}
                                                                onChange={(e) => handleChange(item.id, 'sowc', e.target.value)}
                                                                onBlur={() => handleSave(item.id)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') handleSave(item.id); }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-group input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control height32"
                                                                value={editingData[item.id]?.huong ?? item.huong}
                                                                onChange={(e) => handleChange(item.id, 'huong', e.target.value)}
                                                                onBlur={() => handleSave(item.id)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') handleSave(item.id); }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-group input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control height32"
                                                                value={editingData[item.id]?.dientich ?? item.dientich}
                                                                onChange={(e) => handleChange(item.id, 'dientich', e.target.value)}
                                                                onBlur={() => handleSave(item.id)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') handleSave(item.id); }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-group input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control height32"
                                                                value={editingData[item.id]?.giaban ?? item.giaban}
                                                                onChange={(e) => handleChange(item.id, 'giaban', e.target.value)}
                                                                onBlur={() => handleSave(item.id)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') handleSave(item.id); }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <p className="mb-0">{item.giaban ? item.giaban.toLocaleString('vi-VN') : null}</p>
                                                    </td>
                                                    <td>
                                                        <div className="form-group input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control height32"
                                                                value={editingData[item.id]?.giacoc ?? item.giacoc}
                                                                onChange={(e) => handleChange(item.id, 'giacoc', e.target.value)}
                                                                onBlur={() => handleSave(item.id)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter') handleSave(item.id); }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <p className="mb-0">{item.giacoc ? item.giacoc.toLocaleString('vi-VN') : null}</p>
                                                    </td>
                                                    <td>
                                                        <div className="form-group input-group">
                                                            <select
                                                                className="form-control form-select-sm"
                                                                value={editingData[item.id]?.status ?? item.status}
                                                                onChange={(e) => handleChange(item.id, 'status', Number(e.target.value))}
                                                            >
                                                                {STATUS_OPTIONS.map(opt => (
                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                ))}
                                                            </select>
                                                            <div className="input-group-append">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={() => handleSave(item.id)}>
                                                                    <i className="fas fa-save"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {checkOptions(editingData[item.id]?.status ?? item.status, item)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <h4 className="w-100 text-center mt-3">Không tìm thấy dữ liệu khớp với bộ lọc</h4>
                            )}
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </div >
    );
}